import type {
  DetailedHTMLProps,
  HTMLAttributes,
  PropsWithChildren,
} from "react";

import type { IIconName } from "@icon";

export enum ILinkButtonSizeEnum {
  Medium = "medium",
  Small = "small",
}

export enum ILinkButtonVariantsEnum {
  Gray = "gray",
  Black = "black",
  Primary = "primary",
  Secondary = "secondary",
  Error = "error",
  Success = "success",
  Modifiable = "modifiable",
}

export interface ILinkButtonProps
  extends
    PropsWithChildren,
    DetailedHTMLProps<HTMLAttributes<HTMLButtonElement>, HTMLButtonElement> {
  size?: ILinkButtonSizeEnum;
  variant?: ILinkButtonVariantsEnum;
  linkTo?: string;
  label?: string;
  startIcon?: IIconName;
  endIcon?: IIconName;
  hasUnderline?: boolean;
  className?: string;
  disabled?: boolean;
  isLoading?: boolean;
}
